/**
 * @public
 * @group Enums
 * @category Base
 */
export enum PlayerStatus {
	Initializing = 'Initializing',
	Playing = 'Playing',
	Paused = 'Paused',
	Buffering = 'Buffering',
	Seeking = 'Seeking',
	Ended = 'Ended',
	Error = 'Error'
}
